var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-modal',{attrs:{"name":"router-guide","title":_vm.title,"width":800},on:{"hide":function($event){_vm.step = 1}}},[_c('div',[_c(`step-${_vm.step}`,{tag:"component",on:{"next":function($event){_vm.step++},"back":function($event){_vm.step--},"title":_vm.setTitle,"complete":function($event){_vm.step = 5}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }